import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import axios from 'axios';
import API from "../../API";
import './bidderAlmost.css';
import {Helmet} from "react-helmet";
import Main from "../../layout/main";
import {Col, Container, Row} from "reactstrap";

const BidderAlmost = (props) => {

    const {
        project_id,
        provider_project_id,
        // project_number,
        amount_pay_to_provider,
        bid_amount,
        discount_amount,
        discount_code,
        hours,
        bid_type,
        is_pro,
        project_name,
        project_number,
        project_sub_type_image,
        project_type_name,
        provider_avatar,
        provider_name,
        provider_project_number,
        rating_all_together,
        reviews_all_together,
        years_of_experience,
        the_project_id,
        history,
        from,
        provider_deleted,
        provider_is_visible
    } = props;

    const [time, setTime] = useState("05: 00");

    const startTickDown = (duration) => {
        var timer = duration, minutes, seconds;

        setInterval(function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            setTime(`${minutes}: ${seconds}`)
            if (minutes == "00" && seconds == "00") {
                window.location.href = "/dashboard"
            }
            if (--timer < 0) {
                timer = duration;
            }

        }, 1000);
    }

    const LockProject = () => {
        startTickDown(60 * 5)
        const data = {};
        axios.put(API.baseURL + "/v2/customers/projects/" + the_project_id + "/project_locked", data, API.options)
            .then(res => {
                // startTickDown(60 * 10)
            })
    }

    useEffect(() => {
        // if (from === "bid") {
        LockProject();
        // }
    }, []);

    const [loadingShow, setLoadingShow] = useState(false);
    const [hireSuccessModal, setHireSuccessModal] = useState(false);
    
    const hireProvider = () => {
        const data = {
            project_number: provider_project_number
        }
        setLoadingShow(true);
        axios.post(API.baseURL + API.endPoints.confirmHire + project_id + "/confirm_hire", data, API.options)
            .then(res => {
                setLoadingShow(false);
                setHireSuccessModal(true);
                // window.location.href = `/project-detail/${project_id}/my_projects`;
            })
    }
    const [removeCouponLoadingShow, setRemoveCouponLoadingShow] = useState(false);
    const removeCoupon = () => {
        setRemoveCouponLoadingShow(true);
        axios.get(
            API.baseURL + `/projects/remove_discount_coupon?project_id=${the_project_id}`, API.options
        )
            .then(response => response.data.data)
            .then(res => {
                setRemoveCouponLoadingShow(true);
                window.location.reload();
            })
            .catch(err => {
                // this.props.history.push('/project-not-found')
            });
    }
    
    const handleCloseModal = () => {
        setHireSuccessModal(false);
        window.location.href = `/project-detail/${project_id}/my_projects`;
    }

    return (
        <div>
            <Main >
                <section className="ebw-section__pages">
                    <Container >
                        <Row>
                            <Col lg={{size: 8, offset: 2}}>
                                <div
                                    className="ec-bidder__npayment-time">
                                    <div className="ec-bidder__nservice-blurb d-flex align-items-center">
                                        <img
                                            src={project_sub_type_image ? project_sub_type_image : "/assets/images/New-files/default-card-img-a.png"}
                                            alt="" className="ec-bidder__nservice-blurb-icon mr-2"/>
                                        <div className="ec-bidder__nservice-blurb-caption">
                                            <div className="ec-bidder__nservice-blurb-heading">{project_name}</div>
                                            <div
                                                className="ec-bidder__nservice-blurb-subheading">{project_type_name}</div>
                                        </div>
                                    </div>

                                    <div className="ec-bidder__nproject-id d-flex pb-1 pt-1 mb-4">
                                        <div
                                            className="ec-bidder__nproject-id-left d-flex align-items-center mlr-1">
                                            <img src="/assets/images/New-files/information-circle-outline.svg"
                                                 alt=""
                                                 className="mr-2"/><span>Project ID :</span>
                                        </div>
                                        <div
                                            className="ec-bidder__nproject-id-right  d-flex align-items-center ml-1">
                                            <span>{project_number}</span><img
                                            src="/assets/images/New-files/feather-copy.svg"
                                            alt="" className="ml-2"/>
                                        </div>
                                    </div>

                                    <div className=" d-flex align-items-center justify-content-between">
                                        <div className="ec-bidder__npayment-time-text">Hire your provider now!</div>
                                        <div className="ec-bidder__npayment-time-box">
                                            {time}
                                            <div className="d-flex justify-content-between">
                                                <div className="ec-bidder__npayment-time-label">Min</div>
                                                <div className="ec-bidder__npayment-time-label">Sec</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ec-bidder__almost">
                                    <div className="ec-bidder__nproject-id d-flex pb-15 pt-15 mb-3">
                                        <div className="ec-bidder__nproject-id-left d-flex align-items-center mlr-1">
                                            <img src="/assets/images/New-files/information-circle-outline.svg" alt=""
                                                 className="mr-2"/><span>Project ID :</span>
                                        </div>
                                        <div className="ec-bidder__nproject-id-right  d-flex align-items-center ml-1">
                                            <span>{project_number}</span><img
                                            src="/assets/images/New-files/feather-copy.svg"
                                            alt="" className="ml-2"/>
                                        </div>
                                    </div>
                                    <div className="ec-bidder__nprofile d-flex">
                                        <img
                                            src={provider_avatar ? provider_avatar : "/assets/images/New-files/default-card-img-a.png"}
                                            alt="" className="ec-bidder__nprofile-avatar ec-nproject__avatar mr-3"
                                        />
                                        <div className="ec-ip__ncard-header-data">
                                            <div className="d-flex">
                                                <span><p
                                                    className="ec-ip__ncard-header-data-title ec-nproject__title">{provider_name}</p></span>
                                                {is_pro &&
                                                    <span
                                                        className="ec-ip__ncard-header-data-badge ec-nproject__badge ml-2">Pro+</span>
                                                }
                                            </div>
                                            <div className="ec-ip__ncard-header-data-rating d-flex align-items-center">
                                                <div className="ec-ip__ncard-header-data-rating-num ec-nproject__rating-blurb">
                                                    <span> {rating_all_together}</span>
                                                    <span className="ml-1">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFD700">
                                                            <path
                                                                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                                                        </svg>
                                                    </span>
                                                </div>
                                                <div
                                                    className="ec-ip__ncard-header-data-rating-count ec-nproject__rating-count ml-2  mr-2">{reviews_all_together} ratings
                                                </div>
                                                <div
                                                    className="ec-ip__ncard-header-data-rating-yrcount ec-nproject__rating-ycount">{years_of_experience}+
                                                    years
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ec-bidder__cbreakdown pb-15 pt-15 mt-10">
                                    <div className="ec-bidder__cbreakdown-header">Total cost breakdown</div>
                                    {bid_type ? <>
                                        <div className="ec-bidder__cbreakdown-bamount d-flex justify-content-between mb-10">
                                            <div className="ec-bidder__cbreakdown-bamount-left ">Bid amount</div>
                                            <div className="ec-bidder__cbreakdown-bamount-right">${bid_amount}/hr</div>
                                        </div>
                                        <div className="d-flex justify-content-between  pb-3">
                                            <div className="ec-bidder__cbreakdown-bapprox-left">Approx. hr</div>
                                            <div className="ec-bidder__cbreakdown-bapprox-right">{hours}</div>
                                        </div>
                                    </> : <>
                                        <div className="d-flex justify-content-between  pb-3">
                                            <div className="ec-bidder__cbreakdown-bamount-left ">Bid amount</div>
                                            <div className="ec-bidder__cbreakdown-bamount-right">${bid_amount}</div>
                                        </div>
                                    </>
                                    }
                                    {discount_code && discount_code &&
                                        <div className="ec-bidder__cbreakdown-bamount d-flex justify-content-between mb-10">
                                            <div
                                                className="ec-bidder__cbreakdown-bamount-left ec-bidder__cbreakdown-text--green ">Discount
                                                applied!
                                            </div>
                                            <div
                                                className="ec-bidder__cbreakdown-bamount-right ec-bidder__cbreakdown-text--green">${discount_amount}</div>
                                        </div>
                                    }
                                    <div
                                        className="ec-bidder__cbreakdown-total d-flex justify-content-between ec-bidder__cbreakdown-bapprox pt-3">
                                        <div className="ec-bidder__cbreakdown-bamount-left"><b>Total amount due to Provider</b>
                                        </div>
                                        <div
                                            className="ec-coupon__btn-enter ec-btn__plain--blue ec-text text-uppercase">${amount_pay_to_provider}</div>
                                    </div>
                                    <div className="ec-bidder__nproject-id-left d-flex pb-15 pt-15">
                                        <img src="/assets/images/New-files/information-circle-outline.svg" alt=""
                                             className="mr-2"/>
                                        <span className="alert-text">Please consult with your service provider for payment schedules.</span>
                                    </div>

                                </div>
                                {/* <div className="ec-bidder__ncoupon">
                                    <Link to={`/coupon/${the_project_id}/${provider_project_number}/${provider_project_id}`} href="#" className="d-flex justify-content-between align-items-center">
                                        <div className="ec-bidder__ncoupon-left d-flex align-items-center">
                                            <img className="ec-bidder__ncoupon-icon mr-2" src="/assets/images/New-files/coupon-starred.svg" alt="" />
                                            <div className="ec-bidder__ncoupon-caption">Apply Promo</div>
                                        </div>
                                        <div className="ec-bidder__ncoupon-right">
                                            <img src="/assets/images/New-files/chevron.svg" alt="" />
                                        </div>
                                    </Link>

                                    {discount_code &&
                                        <div className="ec-coupon d-flex justify-content-between">
                                            <p className="ec-coupon__code mb-1">{discount_code}</p>
                                            <div className="ec-coupon__btn-enter ec-btn__plain--blue ec-text text-uppercase" onClick={() => removeCoupon()}>Remove</div>
                                        </div>
                                    }
                                </div> */}
                                <div className="ec-bidder__npayment text-center">
                                    <a onClick={() => hireProvider()} className="ec-button__primary text-center"
                                       style={{backgroundColor: '#28a745', borderColor: '#28a745'}}>Hire Provider</a>
                                </div>
                                {loadingShow && (
                                    <div className="loading-overlay">
                                        <div className="loading-content">
                                            <div className="loading-spinner"></div>
                                            <div className="loading-message">Hiring...</div>
                                        </div>
                                    </div>
                                )}
                                {removeCouponLoadingShow && (
                                    <div className="loading-overlay">
                                        <div className="loading-content">
                                            <div className="loading-spinner"></div>
                                            <div className="loading-message">Removing the applied coupon...</div>
                                        </div>
                                    </div>
                                )}
                                
                                {hireSuccessModal && (
                                    <div className="modal-overlay">
                                        <div className="modal-content p-4">
                                            <div>
                                                <h3>Provider Hired Successfully!</h3>
                                                <p>You have successfully hired this provider for your project.</p>
                                            </div>
                                            <div>
                                                <button onClick={handleCloseModal} className="close-button">
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Main>
        </div>
    );
};

export default BidderAlmost;
